import { render } from "./tournament-teams.template.html?vue&type=template&id=95747720&scoped=true"
import script from "./TournamentTeams.vue?vue&type=script&lang=ts"
export * from "./TournamentTeams.vue?vue&type=script&lang=ts"

import "./TournamentTeams.vue?vue&type=style&index=0&id=95747720&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-95747720"

export default script